// extracted by mini-css-extract-plugin
module.exports = {"container":"J6rMxY_dLNKUECZyL9QP6","secondaryText":"-KKyy6wcl-8MJee5uVxIn","mainText":"_1NOc5i0LDeu-pu_0AVwCLr"};